import { render } from "./ConfigureVasionSettings.vue?vue&type=template&id=651c6eaa&scoped=true"
import script from "./ConfigureVasionSettings.vue?vue&type=script&lang=js"
export * from "./ConfigureVasionSettings.vue?vue&type=script&lang=js"

import "./ConfigureVasionSettings.vue?vue&type=style&index=0&id=651c6eaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651c6eaa"]])

export default __exports__